// pages/CalculationSheet/index.tsx
import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Box, CircularProgress, Typography, Alert } from '@mui/material';
import { CalculationSheet } from '../../components/CalculationSheet/CalculationSheet';
import { calculationSheetService, CalculationSheetData } from '../../services/calculationSheet';

const CalculationSheetPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [data, setData] = useState<CalculationSheetData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const printAreaRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!id) {
      setError('工事IDが指定されていません');
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true);
        const calculationData = await calculationSheetService.getById(parseInt(id));
        setData(calculationData);
        setError(null);
      } catch (err) {
        console.error('計算書データの取得に失敗しました:', err);
        setError('計算書データの取得に失敗しました');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handlePrint = () => {
    window.print();
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (loading) {
    return (
      <Container>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (error || !data) {
    return (
      <Container>
        <Box sx={{ my: 3 }}>
          <Alert severity="error">{error || 'データの取得に失敗しました'}</Alert>
          <Box sx={{ mt: 2 }}>
            <Typography
              variant="body2"
              component="button"
              onClick={handleBack}
              sx={{
                cursor: 'pointer',
                backgroundColor: 'transparent',
                border: 'none',
                textDecoration: 'underline',
                color: 'primary.main',
              }}
            >
              ← 戻る
            </Typography>
          </Box>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ 
      my: 3,
      '@media print': {
        p: 0,
        m: 0,
        maxWidth: '100%'
      }
    }}>
      <Box ref={printAreaRef}>
        <CalculationSheet
          data={data}
          onPrint={handlePrint}
          onBack={handleBack}
        />
      </Box>
    </Container>
  );
};

export default CalculationSheetPage;